import {getIntroduction} from "../../api/introduceUnitsAndFeatures";

const state = () => ({
  introduceUnit:{},
})


const getters = {
  get_introduceUnit(state) {
    return state.introduceUnit;
  },
}

const mutations = {
  SET_INTRODUCEUNIT(state,data){
    state.introduceUnit = data;}
}

const actions = {
  async fetchIntroduceUnit({ commit }) {
    try {
      const response = await getIntroduction();
      commit('SET_INTRODUCEUNIT', response.data.results);
    } catch (error) {
      // handle the error here
    }
  },

}




export  default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
